import { GoogleAnalytics4 } from '@backstage-community/plugin-analytics-module-ga4';
import {
  configApiRef,
  createFrontendModule,
  identityApiRef,
} from '@backstage/frontend-plugin-api';
import { AnalyticsImplementationBlueprint } from '@backstage/plugin-app-react';

/**
 * Google Analytics 4, configured under `app.analytics.ga4`.
 *
 * `GoogleAnalytics4` only records a `navigate` event as a page view when its
 * extension id starts with `app`, but the route tracker reports the id of the
 * matched page (`page:catalog`, ...). Navigations are forwarded as coming from
 * `App`, so every page change is a `page_view` and `contentGrouping` still
 * reads the page's plugin id.
 *
 * The extension keeps the package's own id, `analytics:app/ga4`, so it
 * replaces the module that feature discovery installs from the same package.
 */
export const ga4Analytics = AnalyticsImplementationBlueprint.make({
  name: 'ga4',
  params: defineParams =>
    defineParams({
      deps: { configApi: configApiRef, identityApi: identityApiRef },
      factory: ({ configApi, identityApi }) => {
        if (!configApi.has('app.analytics.ga4')) {
          return { captureEvent: () => {} };
        }
        const ga4 = GoogleAnalytics4.fromConfig(configApi, { identityApi });
        return {
          captureEvent: event =>
            ga4.captureEvent(
              event.action === 'navigate'
                ? {
                    ...event,
                    context: { ...event.context, extensionId: 'App' },
                  }
                : event,
            ),
        };
      },
    }),
});

export const ga4Module = createFrontendModule({
  pluginId: 'app',
  extensions: [ga4Analytics],
});
